module.exports = __webpack_public_path__ + "6a89016eea7417f049c18dc5ca403cea.svg";